import { gql } from '@lcs/shared/api';

export const SaveDashboardsMutation = gql`
   mutation SaveDashboards($dashboards: [DashboardInput!]!) {
      dashboard: saveDashboards(dashboards: $dashboards) {
         name
         dashboardId
         userId
         lastSavedColumnLayoutSize
         dashboardTilesConnection {
            items {
               dashboardTileId
               tileViewMode
               totalMillisecondsProcessed
               totalTimesProcessed
               tile {
                  tileId
                  name
                  description
                  typeId
                  canEditRefreshTime
                  isCustom
                  tileViewModeBound {
                     heightLowerBound
                     heightUpperBound
                     widthLowerBound
                     widthUpperBound
                  }
               }
               dashboardTileLayoutConfiguration {
                  dashboardTileLayoutConfigurationId
                  color
                  height
                  width
                  refreshTimeSeconds
                  maxHeight
                  minHeight
                  maxWidth
                  minWidth
                  name
                  column
                  row
               }
               dashboardTileParametersConnection {
                  items {
                     parameterType
                     dashboardTileParameterId
                     dateRange {
                        relativeDate
                        relativeEndDate
                        relativeStartDate
                        startDate
                        endDate
                     }
                     entitiesToInclude {
                        all
                        entityIdsConnection {
                           items {
                              entityId
                              sortOrder
                           }
                        }
                        includeNull
                     }
                     valueBool
                     valueDateRangeParameterId
                     valueDateTime
                     valueEntitiesToIncludeId
                     valueNumeric
                     valueString
                  }
               }
            }
         }
      }
   }
`;
